var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-file-text-o","titulo":"CERTIDÕES"},nativeOn:{"click":function($event){return _vm.$router.push(_vm.rota)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }